import { Injectable } from '@angular/core';
import { HandleErrorService } from './handle-error.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError, retry } from 'rxjs/operators';

export interface CEP {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  unidade: string;
  ibge: string;
  gia: string;
}

@Injectable({
  providedIn: 'root'
})
export class CEPService {
  constructor(
    private http: HttpClient,
    private handleErrorService: HandleErrorService
  ) {}

  getCEP(cep: string): Observable<any> {
    return this.http.get('https://viacep.com.br/ws/' + cep + '/json/ ').pipe(
      map(response => response),
      retry(3),
      catchError(response => this.handleErrorService.handleError(response))
    );
  }
}
